import { render, staticRenderFns } from "./goodsCustomTestDialog.vue?vue&type=template&id=410f8056&scoped=true"
import script from "./goodsCustomTestDialog.vue?vue&type=script&lang=js"
export * from "./goodsCustomTestDialog.vue?vue&type=script&lang=js"
import style0 from "./goodsCustomTestDialog.vue?vue&type=style&index=0&id=410f8056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f8056",
  null
  
)

export default component.exports